export enum DsQueryFilterOperator {
  StringContains = 'STRINGCONTAINS',
  StringEquals = 'STRINGEQUALS',
  IntEquals = 'INTEQUALS',
  DateRangeBetween = 'DATERANGEBETWEEN',
  NumLargerThen = 'NUMLARGERTHEN',
  NumSmallerThen = 'NUMSMALLERTHEN',
  /** Inclusieve numerieke range; value = JSON `{"Start":n,"End":m}`. Werkt ook op enum-kolommen. */
  NumRangeBetween = 'NUMRANGEBETWEEN',
  GuidEquals = 'GUIDEQUALS',
  /** OR-gelijkheid op één property; vereist 2–20 waarden in `values[]` (bij 1 waarde: StringEquals). */
  OrCombinationEquals = 'ORCOMBINATIONEQUALS'
}
